import { useEffect, useState } from 'react';

interface UseScrollZoomOptions {
  maxZoom?: number;
  zoomSpeed?: number;
}

export function useScrollZoom(options: UseScrollZoomOptions = {}) {
  const { maxZoom = 1.15, zoomSpeed = 0.0001 } = options;
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const scrollProgress = Math.min(scrollY / maxScroll, 1);
      
      // Calculate scale: starts at 1, increases as we scroll down
      const newScale = Math.min(1 + (scrollProgress * (maxZoom - 1)), maxZoom);
      setScale(newScale);
    };

    // Initial call
    handleScroll();

    // Add scroll listener
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [maxZoom, zoomSpeed]);

  return scale;
}
